import React from "react";
import { useLGAs } from "newui/features/Company/hooks/useLGAs";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";

interface LGASelectProps
	extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
	selectedId?: number | "";
	state?: string;
}

export const LGASelect: React.FC<LGASelectProps> = ({
	label = "Local Government Area",
	placeholder = "Select LGA",
	state,
	selectedId,
	value: valueProp,
	hasError: hasErrorProp,
	errorText: errorTextProp,
	onChange: onChangeProp,
	name,
	...rest
}) => {
	const { values, isLoading } = useLGAs();
	const formik = useFormikFieldState(name);

	const filteredOptions: SelectOption[] = state
		? values
			.filter((lga) => lga.state === state)
			.map((lga) => ({ value: lga.id, label: lga.name }))
		: [];

	const resolvedValue =
		selectedId !== undefined && selectedId !== ""
			? isLoading
				? undefined
				: filteredOptions.find((o) => o.value === selectedId) ?? null
			: valueProp;

	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		formik.markTouched();
		onChangeProp?.(selected);
	};

	return (
		<SelectWithLabel
			options={filteredOptions}
			isLoading={isLoading}
			label={label}
			placeholder={state ? placeholder : "Please select State first"}
			value={resolvedValue}
			name={name}
			hasError={hasErrorProp || formik.hasError}
			errorText={errorTextProp || formik.errorText}
			onChange={handleChange}
			isDisabled={!state}
			{...rest}
		/>
	);
};
